import { Injectable } from '@angular/core';
import { DataService } from 'app/shared/services/data.service';
import { ConfigurationService } from 'app/shared/services/configuration.service';
import { Observable } from 'rxjs';
import { ISelect } from 'app/shared/models/select.model';
import { map } from 'rxjs/operators';
import { IResult } from 'app/shared/models/result.model';
import { IDtoWorkLeave } from 'app/shared/models/request/work-leave/dto-work-leave.model';
import { IDtoWorkLeaveFilter } from 'app/shared/models/request/work-leave/dto-work-leave-filter.model';
import { IDtoWorkLeaveChangeStatus } from 'app/shared/models/request/work-leave/dto-work-leave-change-status.model';

@Injectable()
export class WorkLeaveService {
    private requestUrl = '';
    constructor(private service: DataService, private configurationService: ConfigurationService) {
        if (this.configurationService.isReady) {
            this.requestUrl = this.configurationService.serverSettings.requestUrl;
        } else {
            this.configurationService.settingsLoaded$.subscribe(x =>
                this.requestUrl = this.configurationService.serverSettings.requestUrl);
        }
    }
    public getCatalogLineInsurances(): Observable<ISelect[]> {
        const url = `${this.requestUrl}api/Dismissals/getLineInsurance/`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCatalogPaymentTypes(): Observable<ISelect[]> {
        const url = `${this.requestUrl}api/Dismissals/getPaymentTypes/`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCatalogLingeringIssuesKeys(typeRiskId: string): Observable<ISelect[]> {
        const url = `${this.requestUrl}api/Inabilities/getLingeringIssuesKey?typeRiskId=${typeRiskId}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getCatalogInabilityControlKey(lingeringIssuesKeyId: string): Observable<ISelect[]> {
        const url = `${this.requestUrl}api/Inabilities/getInabilityControlKey?lingeringIssuesKeyId=${lingeringIssuesKeyId}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getListEmployeeActive(): Observable<IResult> {
        const url = `${this.requestUrl}api/Employees/getListEmployeeActive`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public addWorkLeave(workLeave: IDtoWorkLeave): Observable<IResult> {
        const url =`${this.requestUrl}api/Dismissals/`;
        return this.service.post(url, workLeave).pipe(map((response: any) => {
            return response;
        }));
    }
    public getWorkLeavebyFilters(data: IDtoWorkLeaveFilter): Observable<IResult> {
        const url =`${this.requestUrl}api/Dismissals/getDismissalsbyFilter/`;
        return this.service.post(url, data).pipe(map((response: any) => {
            return response;
        }));
    }
    public changeWorkLeaveStatus(data: IDtoWorkLeaveChangeStatus): Observable<IResult> {
        const url =`${this.requestUrl}api/Dismissals/changeDismissalsChange/`;
        return this.service.post(url, data).pipe(map((response: any) => {
            return response;
        }));
    }
    public downloadTxt(data: any): Observable<IResult> {
        const url =`${this.requestUrl}api/Dismissals/DownloadTXT/`;
        return this.service.post(url, data).pipe(map((response: any) => {
            return response;
        }));
    }
    public getCurrentDate(): Observable<Date> {
        const url =`${this.requestUrl}api/Dismissals/getCurrentDate/`;
        return this.service.get(url).pipe(map((response: any) => {
            return response;
        }));
    }
    public hasDismissalWaiting(employeeId: number): Observable<IResult> {
        const url = `${this.requestUrl}api/Dismissals/hasDismissalWaiting?employeeId=${employeeId}`;
        return this.service.get(url)
            .pipe(
                map((res: any) => {
                    return res;
                })
            );
    }
    public getLastDismissalDate(employeeId: number): Observable<Date> {
        const url =`${this.requestUrl}api/Dismissals/getLastDismissalDate?employeeId=${employeeId}`;
        return this.service.get(url).pipe(map((response: any) => {
            return response;
        }));
    }
}
